import React from 'react';
import PropTypes from 'prop-types';
import GenericIcon from './fontIcons/genericIcon';
import './fontIcons/fontIconStyle.css';

const DeliveredIcon = ({ ...props }) => {
  const { color, size, fontWeight } = props;
  return (
    <GenericIcon
      color={color}
      size={size}
      fontWeight={fontWeight}
      fontClass="icon-ic_check"
    />
  );
};

DeliveredIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  fontWeight: PropTypes.string,
};

export default DeliveredIcon;
